import moment from "moment-timezone";

import { RsvpConfig } from "src/shared/contexts/EventContext";

export const VOLUNTEER_RSVP_DEADLINE = "Friday, September 18, 2026";

export const getRsvpDeadline = (
  rsvp: RsvpConfig,
  now: Date = new Date(),
  isVolunteer = false
): string =>
  isVolunteer
    ? VOLUNTEER_RSVP_DEADLINE
    : moment(now)
        .tz("America/Toronto")
        .isSameOrAfter(
          moment.tz(
            rsvp.R2DeadlineDisplayStartDate,
            "YYYY-MM-DD",
            true,
            "America/Toronto"
          ),
          "day"
        )
    ? rsvp.R2Deadline
    : rsvp.R1Deadline;
